var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clone"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9832 3.17977H13.4082V1.90727C13.4082 1.20477 12.8382 0.634766 12.1357 0.634766H10.4382V1.48227C10.4382 1.94977 10.0582 2.32977 9.5907 2.32977H5.3507C4.8832 2.32977 4.5032 1.94977 4.5032 1.48227V0.634766H2.8057C2.1032 0.634766 1.5332 1.20477 1.5332 1.90727V19.7198C1.5332 20.4223 2.1032 20.9923 2.8057 20.9923H10.8632V14.2073H9.1657C7.9957 14.2073 7.0457 13.2573 7.0457 12.0873V8.69477H7.8932V12.0873C7.8932 12.7898 8.4632 13.3598 9.1657 13.3598H10.8632V5.29977C10.8632 4.12977 11.8132 3.17977 12.9832 3.17977ZM6.1982 7.84477H5.3507V6.99727H6.1982V7.84477ZM7.8957 7.84477H7.0482V6.99727H7.8957V7.84477ZM9.5932 7.84477H8.7457V6.99727H9.5932V7.84477ZM15.5307 4.02727H19.7707V4.87477H15.5307V4.02727Z",
    fill: "#0C71C3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5852 5.29977C23.5852 4.59727 23.0152 4.02727 22.3127 4.02727H20.6152V4.87477C20.6152 5.34227 20.2352 5.72227 19.7677 5.72227H15.5277C15.0602 5.72227 14.6802 5.34227 14.6802 4.87477V4.02727H12.9827C12.2802 4.02727 11.7102 4.59727 11.7102 5.29977V13.3573H16.6227L15.2252 11.9598L15.8252 11.3598L17.9452 13.4798C18.1102 13.6448 18.1102 13.9148 17.9452 14.0798L15.8252 16.1998L15.2252 15.5998L16.6227 14.2023H11.7102V23.1073C11.7102 23.8098 12.2802 24.3798 12.9827 24.3798H22.3127C23.0152 24.3798 23.5852 23.8098 23.5852 23.1073V5.29977ZM5.34766 0.634766H9.58766V1.48227H5.34766V0.634766Z",
    fill: "#0C71C3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClone);
export default __webpack_public_path__ + "static/media/Clone.b8de6a1a539919aad1c7766f2a25527f.svg";
export { ForwardRef as ReactComponent };